// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grid layout for analytics page */
.analytics-grid {
  display: grid;
  grid-template-columns: 1fr 60px; /* Main content + right sidebar */
  height: 100vh;
  overflow: hidden;
}

/* Left Sidebar */
.left-sidebar {
  background-color: #e8f1f5;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  display: none; /* Keep it hidden to avoid layout issues */
}

.main-content {
  flex: 1 1;
  padding: 20px;
  height: calc(100vh - 10px); 
  width: 90%;
  overflow-y: scroll;
}

/* Extend the Filter Bar to fill available space */
.A-filter-bar {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #e7f0fa;
  border-radius: 8px;
  margin: 0px 118px 2px -15px; /* Uniform margin */
  z-index: 10;
  gap: 10px;
  flex-wrap: wrap; /* Ensure elements wrap on smaller screens */
}

/* Input Container for Side-by-Side Inputs */
.A-filter-bar .input-container {
  display: flex;
  gap: 10px;
  flex-grow: 1;
}

.A-filter-bar input[type="text"] {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  max-width: 300px;
}

/* Filter Options Styling */
.A-filter-bar .filter-options {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Buttons in the Filter Bar */
.A-filter-bar button {
  padding: 8px 16px;
  background-color: #5bc0de;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  margin-left: 10px;
}

/* Filter Options */
.filter-options {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.filter-options select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Apply and Reset Buttons */
#applyFilters,
#resetFilters {
  padding: 8px 12px;
  background-color: #65CCB7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

#applyFilters:hover,
#resetFilters:hover {
  background-color: #56b29a;
}

/* Chart Header */
.chart-header {
  position: absolute;
  top: 10px;
  left: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* View Icon */
.view-icon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 24px;
  cursor: pointer;
}

/* Grid for Charts */
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 20px;
  margin-left: 8px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Chart Container */
.chart-container {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 10px;
  position: relative;
  height: 500px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  margin-bottom: 0px;
}

.chart-container.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Filter Bar */
.filter-bar {
  display: flex;
  align-items: center;
  background-color: #e7f0fa;
  color: #333;
  border-radius: 8px;
  padding: 10px;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 15px;
  margin-left: -15px;
  width: 92.6%;
}

/* Filter Button Styling */
.filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: none;
  border-radius: 25px;
  padding: 8px 15px;
  font-size: 14px;
  color: #333;
  background-color: #e7f0fa;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease;
}

.filter-button:hover {
  background-color: #65CCB7;
}

.filter-button span {
  font-size: 18px;
  margin-right: 5px;
}

/* Separator Line */
.separator {
  height: 30px;
  width: 2px;
  background-color: green;
  margin: 0 7px;
}

/* Time Filters */
.time-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 10px;
}

.time-button {
  background-color: #e7f0fa;
  border: none;
  border-radius: 25px;
  color: #333;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
}

.time-button.active {
  background-color: #65CCB7;
  color: white;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-picker {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.dropdown-wrapper-analytics {
  position: relative;
  display: inline-block;
}

.dropdown-content-analytics {
  display: block;
  position: absolute;
  background-color: #e7f0fa;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 10px;
  min-width: 150px;
  z-index: 1;
}

.dropdown-content-analytics label {
  display: flex;
  align-items: center;
  margin-bottom: 5px; /* Space between each item */
  padding: 5px;
  cursor: pointer;
  font-size: 14px; /* Adjust font size for better readability */
}

.dropdown-content-analytics label:hover {
  background-color: #dceaf6; /* Highlight item on hover */
}

.dropdown-content-analytics input[type="checkbox"] {
  margin-right: 10px; /* Space between checkbox and label text */
  width: 18px; /* Set checkbox width */
  height: 18px; /* Set checkbox height */
  cursor: pointer; /* Change cursor on hover */
  background-color: #000000; /* Checkbox background */
  border: 2px solid #c9006e; /* Border color */
  border-radius: 4px; /* Rounded corners for custom checkboxes */
  outline: none; /* Remove outline */
  appearance: auto; /* Ensure default styling */
  -webkit-appearance: checkbox; /* Safari compatibility */
  opacity: 1;
}
.dropdown-content-analytics input[type="checkbox"]:checked {
  background-color: #b80000; /* Color when checked */
  border-color: #e40000; /* Border color when checked */
}

/* Media Queries for Responsive Design */
@media (max-width: 1200px) {
  .grid-container {
    grid-template-columns: 1fr;
  }

  .A-filter-bar {
    margin: 0;
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-bar {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .time-filters {
    flex-wrap: wrap;
    justify-content: center;
  }

  .filter-button {
    margin-bottom: 10px;
  }

  .chart-container {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .A-filter-bar .input-container input {
    max-width: 100%; /* Allow input to take full width */
  }

  .date-range {
    flex-direction: column;
    align-items: flex-start;
  }

  .time-filters {
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/analytics/Analytics.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,+BAA+B,EAAE,iCAAiC;EAClE,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,aAAa;EACb,wCAAwC;EACxC,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,SAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B,EAAE,mBAAmB;EAChD,WAAW;EACX,SAAS;EACT,eAAe,EAAE,4CAA4C;AAC/D;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,4BAA4B;EAChD,YAAY;EACZ,eAAe;EACf,eAAe,EAAE,4CAA4C;AAC/D;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,kBAAkB,EAAE,0CAA0C;EAC9D,WAAW,EAAE,uBAAuB;EACpC,YAAY,EAAE,wBAAwB;EACtC,eAAe,EAAE,2BAA2B;EAC5C,yBAAyB,EAAE,wBAAwB;EACnD,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB,EAAE,0CAA0C;EAC9D,aAAa,EAAE,mBAAmB;EAClC,gBAAgB,EAAE,2BAA2B;EAC7C,4BAA4B,EAAE,yBAAyB;EACvD,UAAU;AACZ;AACA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA,wCAAwC;AACxC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe,EAAE,mCAAmC;EACtD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Grid layout for analytics page */\r\n.analytics-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 60px; /* Main content + right sidebar */\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Left Sidebar */\r\n.left-sidebar {\r\n  background-color: #e8f1f5;\r\n  padding: 20px;\r\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\r\n  display: none; /* Keep it hidden to avoid layout issues */\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  padding: 20px;\r\n  height: calc(100vh - 10px); \r\n  width: 90%;\r\n  overflow-y: scroll;\r\n}\r\n\r\n/* Extend the Filter Bar to fill available space */\r\n.A-filter-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: #e7f0fa;\r\n  border-radius: 8px;\r\n  margin: 0px 118px 2px -15px; /* Uniform margin */\r\n  z-index: 10;\r\n  gap: 10px;\r\n  flex-wrap: wrap; /* Ensure elements wrap on smaller screens */\r\n}\r\n\r\n/* Input Container for Side-by-Side Inputs */\r\n.A-filter-bar .input-container {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.A-filter-bar input[type=\"text\"] {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n  max-width: 300px;\r\n}\r\n\r\n/* Filter Options Styling */\r\n.A-filter-bar .filter-options {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n/* Buttons in the Filter Bar */\r\n.A-filter-bar button {\r\n  padding: 8px 16px;\r\n  background-color: #5bc0de;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: white;\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Filter Options */\r\n.filter-options {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 10px;\r\n}\r\n\r\n.filter-options select {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Apply and Reset Buttons */\r\n#applyFilters,\r\n#resetFilters {\r\n  padding: 8px 12px;\r\n  background-color: #65CCB7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n#applyFilters:hover,\r\n#resetFilters:hover {\r\n  background-color: #56b29a;\r\n}\r\n\r\n/* Chart Header */\r\n.chart-header {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 20px;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n/* View Icon */\r\n.view-icon {\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n  width: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Grid for Charts */\r\n.grid-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 20px;\r\n  padding: 20px;\r\n  margin-left: 8px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Chart Container */\r\n.chart-container {\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  position: relative;\r\n  height: 500px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.5s ease-in-out;\r\n  overflow: hidden;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.chart-container.fullscreen {\r\n  position: fixed !important;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 9999;\r\n  background: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Filter Bar */\r\n.filter-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #e7f0fa;\r\n  color: #333;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 15px;\r\n  margin-left: -15px;\r\n  width: 92.6%;\r\n}\r\n\r\n/* Filter Button Styling */\r\n.filter-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: white;\r\n  border: none;\r\n  border-radius: 25px;\r\n  padding: 8px 15px;\r\n  font-size: 14px;\r\n  color: #333;\r\n  background-color: #e7f0fa;\r\n  cursor: pointer;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.filter-button:hover {\r\n  background-color: #65CCB7;\r\n}\r\n\r\n.filter-button span {\r\n  font-size: 18px;\r\n  margin-right: 5px;\r\n}\r\n\r\n/* Separator Line */\r\n.separator {\r\n  height: 30px;\r\n  width: 2px;\r\n  background-color: green;\r\n  margin: 0 7px;\r\n}\r\n\r\n/* Time Filters */\r\n.time-filters {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.time-button {\r\n  background-color: #e7f0fa;\r\n  border: none;\r\n  border-radius: 25px;\r\n  color: #333;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.time-button.active {\r\n  background-color: #65CCB7;\r\n  color: white;\r\n}\r\n\r\n.date-range {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.date-picker {\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n  cursor: pointer;\r\n}\r\n\r\n.dropdown-wrapper-analytics {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.dropdown-content-analytics {\r\n  display: block;\r\n  position: absolute;\r\n  background-color: #e7f0fa;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  min-width: 150px;\r\n  z-index: 1;\r\n}\r\n\r\n.dropdown-content-analytics label {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 5px; /* Space between each item */\r\n  padding: 5px;\r\n  cursor: pointer;\r\n  font-size: 14px; /* Adjust font size for better readability */\r\n}\r\n\r\n.dropdown-content-analytics label:hover {\r\n  background-color: #dceaf6; /* Highlight item on hover */\r\n}\r\n\r\n.dropdown-content-analytics input[type=\"checkbox\"] {\r\n  margin-right: 10px; /* Space between checkbox and label text */\r\n  width: 18px; /* Set checkbox width */\r\n  height: 18px; /* Set checkbox height */\r\n  cursor: pointer; /* Change cursor on hover */\r\n  background-color: #000000; /* Checkbox background */\r\n  border: 2px solid #c9006e; /* Border color */\r\n  border-radius: 4px; /* Rounded corners for custom checkboxes */\r\n  outline: none; /* Remove outline */\r\n  appearance: auto; /* Ensure default styling */\r\n  -webkit-appearance: checkbox; /* Safari compatibility */\r\n  opacity: 1;\r\n}\r\n.dropdown-content-analytics input[type=\"checkbox\"]:checked {\r\n  background-color: #b80000; /* Color when checked */\r\n  border-color: #e40000; /* Border color when checked */\r\n}\r\n\r\n/* Media Queries for Responsive Design */\r\n@media (max-width: 1200px) {\r\n  .grid-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .A-filter-bar {\r\n    margin: 0;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .filter-bar {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .time-filters {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n\r\n  .filter-button {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chart-container {\r\n    height: 300px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .A-filter-bar .input-container input {\r\n    max-width: 100%; /* Allow input to take full width */\r\n  }\r\n\r\n  .date-range {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .time-filters {\r\n    justify-content: space-between;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
